// tslint:disable
import { get } from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
import { DatepickerField } from '../../components/fields/datepicker.field';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { SelectField } from '../../components/fields/select.field';
import { ConsoleLib } from '../../components/libs/console.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ListConsole } from '../../components/structurals/list-console';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { Pagination } from '../../components/structurals/pagination';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';

export class DefaultArticleDestinationList extends React.Component<any, any> {

    async handleItemDelete(item: any, list: ListLib, listActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();
        list.isLoading$.next(true);
        await listActions.delete(item['@id']);
        list.refetch();
    }

    componentWillMount() {
        // const metadataReader = new MetadataReaderLib(null);
    }

    render() {
        return (
            <ListResourceLoader entity={this.props.ENTITY} render={(list: ListLib) => <div>
                <div id="page-title">
                    <h2>
                        Articles (Destination / Location)
                        <div className="pull-right">
                            <a href="/article-destination/create" className='btn btn-sm btn-primary'>Create new Article Destination</a>
                        </div>
                    </h2>
                    <p>Lorem</p>

                </div>

                <ListConsole
                    className="col-xs-12 col-lg-3 pull-right"
                    config={list.console}
                    render={(console: ConsoleLib) => <div>
                        <InputField field={console.setQuery('_keyword', {title: 'Search', placeholder: 'some keyword'})}/>

                        <SelectField
                            field={console.setQueryByObj('order', {title: 'OrderBy'})}
                            encode={(i: any) => i}
                            decode={(i: any) => i}
                            options={[
                                {label: 'Category - ASC', value: {kValue: 'category', vValue: 'ASC'}},
                                {label: 'Category - DESC', value: {kValue: 'category', vValue: 'DESC'}},
                                {label: 'Published At - ASC', value: {kValue: 'publishedAt', vValue: 'ASC'}},
                                {label: 'Published At - DESC', value: {kValue: 'publishedAt', vValue: 'DESC'}},
                            ]}
                        />

                        <CheckboxField field={console.setQuery('featured', {title: 'Featured'})}/>

                        <DatepickerField field={console.setQuery('createdAt[after]', {title: 'Created at'})}/>

                        <IriField
                            field={console.setQuery('destination', {title: 'Destination', iri: 'country'})}  // @TODO IRIField valtoazskor nincs az ertek a queryben - emit
                            defaultAll={true}
                            itemRender={(item: any) => item.title}
                        />

                    </div>}
                />

                <div className="col-xs-12 col-lg-9 pull-left relative">
                    <LoaderComponent isLoading$={list.isLoading$}/>

                    <ListResponsePresenterTable
                        items={list.member}
                        head={() => {
                            return (
                                <tr>
                                    <td>#</td>
                                    <td>Title</td>
                                    <td>Destination</td>
                                    <td>Cover</td>
                                    <td>Promo cover</td>
                                    <td>Published</td>
                                    <td>Featured</td>
                                    <td className="fixed-column"/>
                                </tr>
                            );
                        }}
                        row={(item: any, index: number, actions: ListActions) => {
                            return (
                                <tr key={index}>
                                    <td>{get(item, 'id', '-')}</td>
                                    <td>
                                        <a href="" onClick={() => actions.open(item['@id'])}>
                                            {get(item, 'title', '-')}
                                        </a>
                                    </td>
                                    <td>
                                        <IriPresenter iri={get(item, 'destination.@id')} path={'title'}/>
                                    </td>
                                    <td>
                                        {get(item, 'cover') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        {get(item, 'promoCover') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        {get(item, 'publishedAt') ? moment(get(item, 'publishedAt')).format('DD/MM/Y H:mm') : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        {get(item, 'featured') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td className="text-center fixed-column">
                                        <button className="btn btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>View details</button>
                                    </td>
                                </tr>
                            );
                        }}/>

                    <Pagination config={list.pagination}/>

                </div>
            </div>}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/default.article-destination.list.tsx